var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportDeleteLconfig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.01834 2.05393C7.26465 1.80488 7.59675 1.66667 7.94106 1.66667H12.0589C12.4033 1.66667 12.7354 1.80488 12.9817 2.05393C13.2283 2.30328 13.3685 2.64342 13.3685 3V5H6.63154V3C6.63154 2.64342 6.77172 2.30328 7.01834 2.05393ZM4.96487 5V3C4.96487 2.2073 5.27622 1.44524 5.83333 0.881944C6.39075 0.318333 7.14874 0 7.94106 0H12.0589C12.8513 0 13.6092 0.318333 14.1667 0.881944C14.7238 1.44524 15.0351 2.2073 15.0351 3V5H19.2857C19.6802 5 20 5.3731 20 5.83333C20 6.29357 19.6802 6.66667 19.2857 6.66667H16.6668V17C16.6668 17.7927 16.3554 18.5548 15.7983 19.1181C15.2409 19.6817 14.4829 20 13.6906 20H6.30952C5.5172 20 4.75921 19.6817 4.20179 19.1181C3.64468 18.5548 3.33333 17.7927 3.33333 17V6.66667H0.714286C0.319797 6.66667 0 6.29357 0 5.83333C0 5.3731 0.319797 5 0.714286 5H4.96487ZM5 6.66667V17C5 17.3566 5.14018 17.6967 5.3868 17.9461C5.63311 18.1951 5.96521 18.3333 6.30952 18.3333H13.6906C14.0349 18.3333 14.367 18.1951 14.6133 17.9461C14.8599 17.6967 15.0001 17.3566 15.0001 17V6.66667H5Z",
    fill: "#2468FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportDeleteLconfig);
export default __webpack_public_path__ + "static/media/import_delete_lconfig.9e254ac37741f9a3ce00f72eeb7ab46c.svg";
export { ForwardRef as ReactComponent };